import SiafLiteApiRepository from "../../external/siafLiteApi";

class CodigosServicosNacionalService {
  constructor() {
    this.urlBase = "/estoque/codigos-servicos-nacionais";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }
}

export default CodigosServicosNacionalService;
